import { render, staticRenderFns } from "./RolesMultilanguage.vue?vue&type=template&id=7d24687e"
import script from "./RolesMultilanguage.vue?vue&type=script&lang=js"
export * from "./RolesMultilanguage.vue?vue&type=script&lang=js"
import style0 from "./RolesMultilanguage.vue?vue&type=style&index=0&id=7d24687e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports